import { render } from "./DraggableList.vue?vue&type=template&id=67b3fcfb&scoped=true&ts=true"
import script from "./DraggableList.vue?vue&type=script&lang=ts"
export * from "./DraggableList.vue?vue&type=script&lang=ts"

import "./DraggableList.vue?vue&type=style&index=0&id=67b3fcfb&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b3fcfb"]])

export default __exports__